import React from 'react';
import PropTypes from 'prop-types';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

export default function ChooseSelectorStep(props) {
  const { selectorType, onSelectorTypeChange } = props;

  const handleChangeSelectorType = (event) => {
    if(onSelectorTypeChange) {
      onSelectorTypeChange(event.target.value);
    } else {
      console.log("WARNING: no onSelectorTypeChange event handler specified");
    }
  };

  return (
    <FormControl component="fieldset">
      <FormLabel style={{marginBottom: "16px"}} component="legend">How do you want to select inputs?</FormLabel>
      <RadioGroup aria-label="selector type" name="selectorType" value={selectorType} onChange={handleChangeSelectorType}>
        <FormControlLabel value="partitions" control={<Radio color="primary"/>} label="Choose the partitions to process." />
        <FormControlLabel value="list" control={<Radio color="primary"/>} label="Provide a list of objects." />
        <FormControlLabel value="execution" control={<Radio color="primary"/>} label="Retry inputs from a previous execution." />
      </RadioGroup>
    </FormControl>
  );
}

ChooseSelectorStep.propTypes = {
  selectorType: PropTypes.oneOf(['partitions','list','execution']).isRequired,
  onSelectorTypeChange: PropTypes.func,
};

